import { useRemoteModulePreload } from "./remote-module-preload";
import { remoteModuleRefs, getRemotePageParameters, useFederatedPageParameters as useFPP } from "../hooks/useFederatedPageParameters";
export { remoteModuleRefs, getRemotePageParameters };
// @deprecated
export function useFederatedTargetPageParameters(param) {
    var remote = param.remote, mod = param.module;
    // If we are server side mark this module for preload
    useRemoteModulePreload({
        remote: remote,
        module: mod
    });
    // All functionality was migrated to this hook
    // Except for the useRemoteModulePreload call above
    return useFPP({
        remote: remote,
        module: mod
    });
}

//# sourceMappingURL=federated-target-page-parameters.js.map